// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import 'primeicons/primeicons.css'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import VueCryptojs from 'vue-cryptojs'
import VueClipboard from 'vue-clipboard2'
import VueSweetalert2 from 'vue-sweetalert2'
import VueMeta from 'vue-meta'
// import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'
import VueQRCodeComponent from 'vue-qrcode-component'

import Carousel3d from 'vue-carousel-3d'

Vue.use(Carousel3d)

// import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// Vue.use(BootstrapVue)
// Vue.use(BootstrapVueIcons)
// // you have to import bootstrap css.
// import 'bootstrap/dist/css/bootstrap.min.css'
// // import bootstrap icons (this is not required, you can use your own icon class)
// import 'bootstrap-icons/font/bootstrap-icons.css'
// Vue.use(Vuetify)
Vue.use(VueClipboard)
Vue.use(VueCryptojs)
Vue.use(VueCookies)
Vue.use(Vuex)
Vue.use(VueSweetalert2)
Vue.use(VueMeta, {
  keyName: 'head',
})
Vue.component('qr-code', VueQRCodeComponent)

import 'sweetalert2/dist/sweetalert2.min.css'
import '@sweetalert2/theme-dark/dark.css'
import 'dayjs/locale/th'

Vue.config.productionTip = false
import numeral from 'numeral'
Vue.filter('formatNumber', function(value) {
  return numeral(value).format('0,0.00')
}) /* eslint-disable no-new */
;(async () => {
  document.title =
    store.state.appName + ' | บาคาร่า สล็อต บอล หวย เกมสนุกๆมากมาย '
  new Vue({
    // vuetify: new Vuetify({
    //   icons: {
    //     iconfont: 'mdi', // default - only for display purposes
    //   },
    // }),
    watch: {
      async $route() {
        window.scrollTo(0, 0)
        // if (this.$route.name == 'Home') {
        //   return true
        // }

        return await store.dispatch('checkAuthIndex')
      },
    },
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
})()



// WEBPACK FOOTER //
// ./src/pages/index/main.js